module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3f0a747ac8a8081f4cb1a48e69d43af7.png";